import * as React from "react";

import ContractForm from "../../../components/Forms/OtherContract/ContractForm/FlowForm";

export default function OtherContractCreate() {
  return <ContractForm />;
}
